/**
 * Admin invites API client — mirrors /admin/invites + /admin/waitlist on
 * tacosai-admin-api (login redesign Slice 3). Invites are EMAIL-BOUND,
 * one-time codes; generate is audited + idempotent (returns the live invite
 * for an address if one exists).
 */
import { request } from './client.js';

export type InviteStatus = 'active' | 'consumed' | 'expired';

export interface AdminInvite {
  id: string;
  code: string;
  email: string;
  status: InviteStatus;
  note: string | null;
  expires_at: string;
  consumed_at: string | null;
  consumed_by: string | null;
  created_at: string;
}

export interface WaitlistEntry {
  id: string;
  email: string;
  note: string | null;
  invited: boolean;
  invited_at: string | null;
  created_at: string;
}

/** Generate (or reuse) an email-bound invite. `reused` = a live one existed. */
export async function generateInvite(body: {
  email: string;
  note?: string;
}): Promise<{ invite: AdminInvite; reused: boolean }> {
  return request<{ invite: AdminInvite; reused: boolean }>({
    method: 'POST',
    url: '/admin/invites',
    body,
  });
}

export async function listInvites(
  status?: InviteStatus | 'all',
): Promise<{ invites: AdminInvite[] }> {
  return request<{ invites: AdminInvite[] }>({
    method: 'GET',
    url: '/admin/invites',
    query: status ? { status } : undefined,
  });
}

export async function revokeInvite(id: string): Promise<{ ok: boolean }> {
  return request<{ ok: boolean }>({ method: 'DELETE', url: `/admin/invites/${id}` });
}

export async function listWaitlist(): Promise<{ waitlist: WaitlistEntry[] }> {
  return request<{ waitlist: WaitlistEntry[] }>({ method: 'GET', url: '/admin/waitlist' });
}
